import React, { useEffect, useRef, useState } from "react";
import { View, Text, TouchableOpacity, StyleSheet, ActivityIndicator, Platform} from "react-native";
import { WebView } from "react-native-webview";
import WebWebView from "react-native-web-webview";
import AsyncStorage from "@react-native-async-storage/async-storage";
import api from "../../services/api";

const CustomWebView = Platform.OS === "web" ? WebWebView : WebView;

const TradeView = ({ idCoin }) => {
    const [tokenCripto, setTokenCripto] = useState(null);
    const [addLineSeries, setAddLineSeries] = useState([]);
    const [addCandlestickSeries, setAddCandlestickSeries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [interval, setInterval] = useState("1d");

    const [binanceData, setBinanceData] = useState([]);

    // Atualiza Webview com tradeview de acordo com atualização de dados
    const webViewRef = useRef(null);
    useEffect(() => {
        if (webViewRef.current) {
            webViewRef.current.reload();
        }
    }, [addLineSeries, addCandlestickSeries, binanceData]);

    // Busca os dados da API
    const fetchData = async () => {
        try {
            const token = await AsyncStorage.getItem("JWT_TOKEN");
            const response = await api.get(`/tradeview/${idCoin}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const { line_series, candlestick_series, token: tokenData } = response.data;

            // Formata os dados da API
            const formattedLineSeries = line_series.map(item => ({
                time: new Date(`${item.time.year}-${item.time.month}-${item.time.day}`).getTime() / 1000,
                value: parseFloat(item.value),
            }));

            const formattedCandlestickSeries = candlestick_series.map(item => ({
                time: new Date(`${item.time.year}-${item.time.month}-${item.time.day}`).getTime() / 1000,
                open: parseFloat(item.open),
                high: parseFloat(item.high),
                low: parseFloat(item.low),
                close: parseFloat(item.close),
            }));

            setTokenCripto(tokenData);
            setAddLineSeries(formattedLineSeries);
            setAddCandlestickSeries(formattedCandlestickSeries);
        } catch (error) {
            console.error("Erro ao buscar dados:", error);
        } finally {
            setLoading(false);
        }
    };

    // Busca os dados da Binance
    const fetchBinanceData = async (interval) => {
        try {
            const token = await AsyncStorage.getItem("JWT_TOKEN");
            const response = await api.get(`/binance/klines?symbol=${tokenCripto.name_token}BRL&interval=${interval}&limit=500`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const data = response.data;

            const formattedData = data.map(item => ({
                time: new Date(item[6]).getTime() / 1000,
                open: parseFloat(item[1]),
                high: parseFloat(item[2]),
                low: parseFloat(item[3]),
                close: parseFloat(item[4]),
            }));

            setBinanceData(formattedData);
        } catch (error) {
            console.error("Erro ao buscar dados da Binance:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [idCoin]);

    useEffect(() => {
        if (tokenCripto) {
            fetchBinanceData(interval);
        }
    }, [interval, tokenCripto]);

    // HTML e JavaScript para o gráfico
    const htmlContent = `
        <!DOCTYPE html>
        <html lang="pt-br">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title> TradeView </title>
            <style>
                .switcher {
                    display: flex;
                    align-items: center;
                    height: 30px;
                    margin-top: 8px;
                    color: #2196F3;
                    text-transform: uppercase;
                    border: 2px solid rgba(197, 203, 206, 1);
                    width: screen.width - 15;
                }
            
                .switcher-item {
                    cursor: pointer;
                    text-decoration: none;
                    display: inline-block;
                    padding: 6px 8px;
                    font-size: 14px;
                    color: #262b3e;
                    background-color: transparent;
                    margin-right: 8px;
                    border: none;
                    border-radius: 4px;
                    outline: none;
                }
            
                .switcher-item:hover {
                    background-color: #f2f3f5;
                }
            
                .switcher-active-item {
                    text-decoration: none;
                    cursor: default;
                    color: #262b3e;
                }
            
                .switcher-active-item,
                .switcher-active-item:hover {
                    background-color: #e1eff9;
                }
            
                html,
                body {
                    font-family: 'Trebuchet MS', Roboto, Ubuntu, sans-serif;
                    background: #f9fafb;
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;
                }
        
                .three-line-legend {
                    width: 200px;
                    height: 70px;
                    position: absolute;
                    padding: 8px;
                    font-size: 12px;
                    color: '#20262E';
                    background-color: rgba(255, 255, 255, 0.23);
                    text-align: left;
                    z-index: 1000;
                    pointer-events: none;
                }
            
                .nameToken{
                    font-size: 24px;
                    margin: 4px 0px;
                    color: #20262E;
                }
                .valorToken{
                    font-size: 24px;
                    margin: 4px 0px;
                    color: #20262E;
                }
                .dataToken{
                    font-size: 14px;
                    margin: 4px 0px;
                    color: #20262E;
                }
        
                @media (max-width: 790px) {
                    .nameToken{
                        font-size: 18px;
                        margin: 4px 0px;
                        color: #20262E;
                    }
                    .valorToken{
                        font-size: 18px;
                        margin: 4px 0px;
                        color: #20262E;
                    }
                    .dataToken{
                        font-size: 10px;
                        margin: 4px 0px;
                        color: #20262E;
                    }
                } 
            </style>
        </head>
        <body>
            <div id="chart"> </div>

            <div id="tooltip" class="three-line-legend"></div>

            <script src="https://unpkg.com/lightweight-charts@3.8.0/dist/lightweight-charts.standalone.production.js"></script>
            <script>
                const token = ${JSON.stringify(tokenCripto)};
                const data1 = ${JSON.stringify(addLineSeries)};
                const data2 = ${JSON.stringify(addCandlestickSeries)};
                const binanceData = ${JSON.stringify(binanceData)};

                <!-- Define altura e largura do box interno do gráfico -->
                const width = screen.width - 950;
                const height = (window.innerHeight);

                const chart = LightweightCharts.createChart(document.getElementById('chart'), {
                    width: width,
                    height: height,
                    rightPriceScale: {
                        visible: true,
                        borderColor: 'rgba(197, 203, 206, 1)',
                    },
                    layout: {
                        backgroundColor: '#ffffff',
                        textColor: 'rgba(33, 56, 77, 1)',
                    },
                    grid: {
                        horzLines: {
                            color: '#F0F3FA',
                        },
                        vertLines: {
                            color: '#F0F3FA',
                        },
                    },
                    crosshair: {
                        mode: LightweightCharts.CrosshairMode.Normal,
                    },
                    timeScale: {
                        borderColor: 'rgba(197, 203, 206, 1)',
                        timeVisible: true,
                        barSpacing: 20,
                    },
                    handleScroll: {
                        vertTouchDrag: false,
                    }
                });

                const volumeSeries = chart.addHistogramSeries({
                    color: '#26a69a',
                    priceFormat: {
                        type: 'volume',
                    },
                    priceScaledId: '',
                    scaleMargins: {
                        top: 0.8,
                        bottom: 0,
                    }
                });

                const lineSeries = chart.addLineSeries({
                    color: 'rgba(4, 111, 232, 1)',
                    lineWidth: 2,
                });

                const candlestickSeries = chart.addCandlestickSeries({
                    upColor: '#008000',
                    downColor: '#FF0000',
                    borderDownColor: '#FF0000',
                    borderUpColor: '#008000',
                    wickDownColor: '#FF0000',
                    wickUpColor: '#008000',
                });

                lineSeries.setData(data1);
                candlestickSeries.setData(data2);

                if (binanceData.length > 0) {
                    candlestickSeries.setData(binanceData);
                }

                chart.timeScale().fitContent();

                const toolTip = document.getElementById('tooltip');
                toolTip.style.display = 'block';
                toolTip.style.left = 3 + 'px';
                toolTip.style.top = 3 + 'px';

                function setLastBarText() {
                    const data = binanceData.length > 0 ? binanceData : data2;
                    const lastBar = data[data.length - 1];
                    const dateStr = new Date(lastBar.time * 1000).toLocaleDateString();
                    toolTip.innerHTML = \`
                        <div class="nameToken">\${token.name_token}BRL</div>
                        <div class="valorToken"> R$ \${lastBar.close.toFixed(2)}</div>
                        <div class="dataToken">\${dateStr}</div>
                    \`;
                }

                setLastBarText();

                chart.subscribeCrosshairMove(param => {
                    if (param === undefined || param.time === undefined || param.point.x < 0 || param.point.x > width || param.point.y < 0 || param.point.y > height) {
                        setLastBarText();
                    } else {
                        const dateStr = new Date(param.time * 1000).toLocaleDateString();
                        const price = param.seriesPrices.get(candlestickSeries);
                        toolTip.innerHTML = \`
                            <div class="nameToken">\${token.name_token}BRL</div>
                            <div class="valorToken"> R$ \${price.close.toFixed(2)}</div>
                            <div class="dataToken">\${dateStr}</div>
                        \`;
                    }
                });
            </script>
        </body>
        </html>
    `;

    if (loading) {
        return <ActivityIndicator size="large" color="#0000ff" />;
    }

    return (
        <View style={{ flex: 1, width: '54vw' }}>
            <CustomWebView
                ref={webViewRef}
                originWhitelist={["*"]}
                source={{ html: htmlContent }}
                javaScriptEnabled
                domStorageEnabled
                style={{ flex: 2 }}
                onLoad={() => console.log("WebView carregada")}
                onError={(syntheticEvent) => {
                    const { nativeEvent } = syntheticEvent;
                    console.error("Erro na WebView:", nativeEvent);
                }}
            />

            <View style={styles.intervalContainer}>
                {["1d", "3d", "1w", "1M"].map((item) => (
                    <TouchableOpacity
                        key={item}
                        style={[
                            styles.intervalButton,
                            interval === item && styles.activeIntervalButton,
                        ]}
                        onPress={() => setInterval(item)}
                    >
                        <Text style={styles.intervalButtonText}>{item.toUpperCase()}</Text>
                    </TouchableOpacity>
                ))}
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    intervalContainer: {
        flexDirection: "row",
        justifyContent: "space-around",
        padding: 10,
        backgroundColor: "#f9fafb",
    },
    intervalButton: {
        padding: 10,
        borderRadius: 5,
        backgroundColor: "#e1eff9",
    },
    activeIntervalButton: {
        backgroundColor: "#2196F3",
    },
    intervalButtonText: {
        color: "#262b3e",
        fontWeight: "bold",
    },
});

export default TradeView;